import { uploadFile as apiUploadFile, deleteFile as apiDeleteFile, getFileBinary as apiGetFileBinary } from 'api/users';
import {
    FILE_UPLOAD_REQUEST,
    FILE_UPLOAD_SUCCESS,
    FILE_DOWNLOAD_REQUEST,
    FILE_DELETE_REQUEST,
    FILE_DELETE_SUCCESS,
} from '../constants/file';

export function fetchFiles() {
    return { type: 'FILES_FETCH_REQUEST' };
}
export function uploadFile(acceptedFiles, rejected, type) {
    return async dispatch => {
        if (rejected.length) return alert('Fejl ved upload');

        await dispatch({ type: FILE_UPLOAD_REQUEST });

        const file = acceptedFiles[0];
        const filename = file.name;
        const fileInfo = { file, filename, type };

        const uploadedFile = await apiUploadFile(fileInfo);

        await dispatch({ type: FILE_UPLOAD_SUCCESS, payload: { file: uploadedFile, fileContent: file } });

        return uploadedFile;
    };
}

export function downloadDocument(payload) {
    return {
        type: FILE_DOWNLOAD_REQUEST,
        payload,
    };
}

export function deleteDocument(payload) {
    return async dispatch => {
        await dispatch({
            type: FILE_DELETE_REQUEST,
            payload });

        const deletedFile = await apiDeleteFile(payload.fileId);

        await dispatch({ type: FILE_DELETE_SUCCESS, payload: { fileId: deletedFile } });
    };
}

export function getFileBinary(fileId) {
    return () => apiGetFileBinary(fileId);
}
